import React, { useState } from "react";
import style from "css/landing.module.css";
import { ReactComponent as Arrow } from "asset/common/arrow.svg";

function ProjectItem(props) {
  const [isHover, setIsHover] = useState(false);

  return (
    <div className={style.project_item_wrap}>
      <div
        className={style.project_item_img_wrap}
        onMouseOver={() => setIsHover(true)}
        onMouseOut={() => setIsHover(false)}
      >
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}` + props.project.img}
          alt="project_img"
          className={style.project_item_img}
        />
        {/* {isHover ? (
          <button className={style.project_item_view_more_btn}>
            <span>View more</span>
            <Arrow fill="#fff" width="22px" height="22px" />
          </button>
        ) : (
          <></>
        )} */}
      </div>

      <div className={style.project_item_customer}>
        {props.project.customer}
      </div>
      <div className={style.project_item}>
        <div
          className={style.project_item_title}
          dangerouslySetInnerHTML={{ __html: props.project.title }}
        ></div>
        <p className={style.project_item_text}>{props.project.text}</p>
      </div>
    </div>
  );
}

export default ProjectItem;
